import React from 'react';
import cx from 'classnames';

export const AvatarLoading = React.forwardRef(({ src, size, className, onClick, ...props}, ref) => {
  return <div ref={ref} className={cx("g-avatar", 'loading-shine', size, className)} {...props} />
});

export const Avatar =  React.forwardRef(({ src, size, className, badge, ...props}, ref) => {
  src = src ?? '/assets/images/default_avatar.png';
  return (
    <div 
      ref={ref} 
      className={cx("g-avatar", size, className)} 
      {...props}>
      <img src={src} />
      { badge 
        ? <div className="badge">{ badge }</div>
        : null}
    </div>);
});
export default Avatar;